import TubCommon from "./tubCommon";

export default class WalkInTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walk_in_tub';
    this.bottomTubId = "walk_in_tub";
    this.visible = true;
    this.partName = 'Walk In Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.walk_in_tub";
    this.isStoneFeature = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new WalkInTub());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.WalkInTub;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

  getFeatureByPartName(partName) {
    if (!partName) {
      return null
    }
    let walkInTubType = null;
    const possibleWalkInTubTypes = [" AMD", " BSC", " WH"];
    for (let i = 0; i < possibleWalkInTubTypes.length; i++) {
      if (partName.includes(possibleWalkInTubTypes[i])) {
        walkInTubType = possibleWalkInTubTypes[i];
        break;
      }
    }
    if (walkInTubType) {
      partName = partName.split(walkInTubType).join("");
    }
    partName = partName.toLowerCase();
    if (partName[partName.length-1] === "r") {
      partName = partName.slice(0, partName.length-1);
    }
    return this.features.find(feature => {
      if (!feature.partName) {
        return false
      }
      let featurePartName = feature.partName;
      if (walkInTubType) {
        featurePartName = featurePartName.split(walkInTubType).join("");
      }
      featurePartName = featurePartName.toLowerCase();
      if (featurePartName[featurePartName.length-1] === "r") {
        featurePartName = featurePartName.slice(0, featurePartName.length-1);
      }
      return partName === featurePartName
    });
  }

}
